import { render, staticRenderFns } from "./HeadingConfig.vue?vue&type=template&id=a7be05ec&scoped=true"
import script from "./HeadingConfig.vue?vue&type=script&lang=js"
export * from "./HeadingConfig.vue?vue&type=script&lang=js"
import style0 from "./HeadingConfig.vue?vue&type=style&index=0&id=a7be05ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7be05ec",
  null
  
)

export default component.exports